module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "excel-wrapper"
  }, [(_vm.sheets.length > 1) ? _c('div', {
    staticClass: "sheet-tabs"
  }, _vm._l((_vm.sheets), function(sheet) {
    return _c('button', {
      key: sheet,
      class: {
        active: sheet === _vm.currentSheet
      },
      on: {
        "click": function($event) {
          _vm.selectSheet(sheet)
        }
      }
    }, [_vm._v("\n            " + _vm._s(sheet) + "\n        ")])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-scroll"
  }, [(_vm.tableData.length) ? _c('table', {
    staticClass: "excel-table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.tableData[0]), function(head, index) {
    return _c('th', {
      key: index
    }, [_vm._v(_vm._s(head))])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData.slice(1)), function(row, rIndex) {
    return _c('tr', {
      key: rIndex
    }, _vm._l((row), function(cell, cIndex) {
      return _c('td', {
        key: cIndex
      }, [_vm._v(_vm._s(cell))])
    }))
  }))]) : _c('p', [_vm._v("No data available")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-330d59d5","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/childComponent/ExcelViewer.vue
// module id = 2507
// module chunks = 0